module.exports = __webpack_public_path__ + "img/outlook_average.caa7b925.png";